"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FILE_TYPES = {
    csv: 'text/csv;charset=utf-8',
    pdf: 'image/*,.pdf',
};
